// extracted by mini-css-extract-plugin
export default {"mainDiv":"product_mainDiv__NN1sK"};